import NonProfitCard from "../components/NonProfitCard.js";
import "./Pages.css";
import CustomPagination from "../components/Pagination.js";
import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";

export default function NonProfitsPage() {
  const [selected, setSelected] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(56);
  const [instanceCount, setInstanceCount] = React.useState([0, 0]);

  const [cardData, setCardData] = React.useState([]);
  const [sortBy, setSortBy] = React.useState("name");
  const [order, setOrder] = React.useState("asc");
  const [category, setCategory] = React.useState(null);
  const [state, setState] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState();
  const [tempSearchTerm, setTempSearchTerm] = React.useState();

  const stateList = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ];

  const categoryList = [
    "aapi-led",
    "adoption",
    "autism",
    "black-led",
    "cancer",
    "climate",
    "conservation",
    "coronavirus",
    "culture",
    "dance",
    "disease",
    "education",
    "environment",
    "food-security",
    "gender-equality",
    "health",
    "housing",
    "humansimmigrants",
    "justice",
    "latine-led",
    "legal",
    "lgbt",
    "mental-health",
    "poverty",
    "racial-justice",
    "refugees",
    "research",
    "seniors",
    "votingrights",
    "water",
    "women-led",
    "womens-health",
    "youth",
  ];

  function onPageChange(value) {
    setSelected(value);
  }

  const handleSortChange = (newSortBy) => {
    if (sortBy === newSortBy) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setSortBy(newSortBy);
      setOrder("asc");
    }
    setSelected(1);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${
            process.env.REACT_APP_FLASK_URL
          }/nonprofits?page=${selected}&sort_by=${sortBy}&order=${order}&state=${state}&category=${category}${
            searchTerm ? `&term=${searchTerm}` : ""
          }`
        );
        const data = await response.json();
        setTotalPages(data.pages);
        setInstanceCount([data.total, data?.nonprofits.length]);
        setCardData(data.nonprofits);
      } catch (error) {
        console.error("Error fetching rows:", error);
      }
    };

    fetchData();
  }, [selected, sortBy, order, category, state, searchTerm]);

  return (
    <>
      <h1 id="non-profit title">Non Profits</h1>
      <div className="container">
        <div className="container d-flex flex-wrap gap-1 justify-content-end mx-auto w-100 mt-3">
          <InputGroup id="search">
            <Form.Control
              size="lg"
              type="text"
              placeholder="Search Nonprofits"
              onChange={(e) => setTempSearchTerm(e.target.value)}
            />
            <Button
              variant="primary"
              onClick={() => setSearchTerm(tempSearchTerm)}
            >
              Search
            </Button>
          </InputGroup>
        </div>
        <div className="container d-flex flex-wrap gap-1 justify-content-end mx-auto w-100">
          <button
            onClick={() => handleSortChange("name")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by Name
            {sortBy === "name" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
          <button
            onClick={() => handleSortChange("ein")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by EIN
            {sortBy === "ein" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
          <button
            onClick={() => handleSortChange("category")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by Category
            {sortBy === "category" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
        </div>
        <div className="container d-flex flex-wrap gap-3 justify-content-end mx-auto">
          <Form.Select
            aria-label="Select State"
            className="w-auto"
            onChange={(e) => setState(e.target.value)}
          >
            <option value="null">Select State</option>
            {stateList.map((state) => (
              <option key={state} value={state}>
                State: {state}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            aria-label="Select Category"
            className="w-auto"
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="null">Select Category</option>
            {categoryList.map((category) => (
              <option key={category} value={category}>
                Category: {category}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      {cardData === null && (
        <div className="container d-flex flex-wrap gap-3 justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <div className="container d-flex flex-column align-items-center">
        <div className="d-flex flex-wrap gap-3 justify-content-center">
          {cardData?.map((nonprofit, index) => (
            <NonProfitCard
              key={index}
              nonprofit={nonprofit}
              searchTerm={searchTerm}
            ></NonProfitCard>
          ))}
        </div>
        <CustomPagination
          last={totalPages}
          selected={selected}
          onPageChange={onPageChange}
          total={instanceCount[0]}
          current={instanceCount[1]}
        ></CustomPagination>
      </div>
    </>
  );
}
